import { useState } from "react";
import ZoomableImage from "./ZoomableImage";
import { detailAspect } from "../../utilities/framing";

// Multi-image viewer for the detail modal, styled after the homepage
// featured carousel but manually driven (no auto-advance while reading).
// Clicking anywhere on the image advances to the next scan (looping back
// to the first after the last), so the image window stays the same width
// as single-image entries; the dots below jump to a specific image.
// The primary image (index 0) uses the item's detail framing; the other
// scans look up their own framing by URL in imageFramings and fall back
// to a default centered cover crop.
// `captions` ([{url, caption}], articles only) overlays the current
// image's caption as a pill on hover, like the featured carousel's label.
export default function DetailCarousel({
  images,
  framing,
  imageFramings,
  captions,
  kind,
  alt,
}) {
  const [index, setIndex] = useState(0);
  const count = images.length;
  const currentFraming =
    index === 0
      ? framing
      : imageFramings?.find((entry) => entry.url === images[index]);
  const caption = captions?.find(
    (entry) => entry.url === images[index],
  )?.caption;

  return (
    <div className="mx-auto" style={{ maxWidth: "min(100%, 93vh)" }}>
      <div
        className="group relative overflow-hidden rounded-md border border-ink/10 bg-cream"
        style={{ aspectRatio: detailAspect(kind) }}
      >
        <ZoomableImage
          key={images[index]}
          src={images[index]}
          alt={`${alt} — image ${index + 1} of ${count}`}
          framing={currentFraming}
          imgClassName="animate-fadeIn"
          onTap={() => setIndex((i) => (i + 1) % count)}
          tapLabel="Next image"
          disabled={kind !== "cover"}
        />
        {caption && (
          <span className="absolute bottom-3 left-1/2 z-20 -translate-x-1/2 max-w-[85%] truncate rounded-full bg-paper/90 border border-ink/10 px-4 py-1.5 font-mono text-xs text-ink shadow-sm opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            {caption}
          </span>
        )}
      </div>
      <div className="flex justify-center gap-2 mt-3">
        {images.map((url, i) => (
          <button
            key={url}
            onClick={() => setIndex(i)}
            aria-label={`Go to image ${i + 1}`}
            className={`w-2 h-2 rounded-full transition-colors ${
              i === index ? "bg-seal" : "bg-ink/15 hover:bg-ink/30"
            }`}
          />
        ))}
      </div>
    </div>
  );
}
